{
  "email": "Email",
  "firstName": "Имя",
  "lastName": "Фамилия",
  "password": "Пароль",
  "back": "Назад",
  "signOut": "Выйти",
  "confirm": "Подтвердить",
  "confirmTitle": "Подтверждение",
  "cancel": "Отмена",
  "cancelCountdown": "Отменить {{seconds}}с.",
  "cancelCountdownShort": "{{seconds}}с.",
  "close": "Закрыть",
  "approve": "Утвердить",
  "save": "Сохранить",
  "saving": "Сохранение…",
  "generate": "Сгенерировать",
  "generating": "Генерация…",
  "platformDisabledModel": "временно отключено платформой",
  "generationPriceHint": "Предварительная стоимость",
  "table": {
    "pinColumn": "Закрепить колонку",
    "unpinColumn": "Открепить колонку",
    "openInPeek": "Открыть сбоку"
  },
  "frameFormat": {
    "vertical": "9:16 — вертикальный",
    "horizontal": "16:9 — горизонтальный",
    "square": "1:1 — квадратный",
    "ultrawide": "21:9 — ультраширокий",
    "portrait34": "3:4 — вертикальный",
    "landscape43": "4:3 — горизонтальный"
  },
  "status": {
    "draft": "Черновик",
    "generated": "Сгенерировано",
    "in_review": "На проверке",
    "approved": "Утверждено",
    "needs_changes": "Нужны правки",
    "locked": "Заблокировано",
    "failed": "Ошибка",
    "queued": "В очереди",
    "processing": "В работе",
    "completed": "Готово",
    "cancelled": "Отменено"
  },
  "referenceInputs": {
    "addFromLibraryPartial": "Не удалось добавить: {{names}}",
    "heading": "Референсы для генерации",
    "sectionTitle": "Референсы",
    "openPreview": "Открыть в полном размере",
    "removeReference": "Удалить референс",
    "removeConfirm": "Удалить этот референс для генерации?",
    "lightboxTitle": "Референс для генерации",
    "addReference": "Добавить референс",
    "dropOrPasteHint": "Перетащите файлы сюда или вставьте картинку из буфера (Ctrl/Cmd+V)",
    "unsupportedFileType": "Неподдерживаемый тип файла",
    "fileTooLarge": "Файл больше {{max}} МБ",
    "videoDurationInvalid": "Длительность видео должна быть от {{min}} до {{max}} секунд",
    "videoDurationUnreadable": "Не удалось определить длительность видео",
    "videoDurationTotalInvalid": "Суммарная длительность видео-референсов не должна превышать {{max}} с (сейчас {{total}} с)",
    "videoDurationBudget": "{{used}} / {{max}} с видео-референсов"
  },
  "imageLightbox": {
    "defaultTitle": "Просмотр изображения",
    "videoTitle": "Просмотр видео",
    "audioTitle": "Просмотр аудио",
    "noImage": "Нет изображения",
    "downloadOriginal": "Скачать оригинал",
    "copy": "Копировать",
    "copyTitle": "Копировать оригинал в буфер обмена",
    "copySuccess": "Оригинал скопирован в буфер обмена",
    "copyError": "Не удалось скопировать изображение"
  },
  "voicePicker": {
    "voice": "Голос",
    "characterVoices": "Голоса героев",
    "librarySection": "Библиотека {{provider}}",
    "libraryBadge": "Библиотека {{provider}}",
    "defaultVoice": "Голос по умолчанию",
    "activeMark": "· основной",
    "searchPlaceholder": "Поиск голоса…",
    "searchEmpty": "Ничего не найдено",
    "libraryLoading": "Загружаем библиотеку…",
    "libraryFailed": "Не удалось загрузить библиотеку.",
    "retry": "Повторить",
    "playPreview": "Прослушать",
    "pausePreview": "Пауза",
    "noVoices": "Голосов нет: подключите аудио-провайдера в настройках Studio."
  },
  "voiceDictation": {
    "start": "Надиктовать промпт",
    "startHold": "Удерживайте, чтобы надиктовать",
    "microphone": "Микрофон",
    "microphoneSettings": "Микрофон и режим записи",
    "defaultMicrophone": "Микрофон по умолчанию",
    "defaultInputNamed": "По умолчанию — {{name}}",
    "microphoneN": "Микрофон {{n}}",
    "microphoneUnavailable": "Выбранный микрофон недоступен — пишем со входа по умолчанию",
    "holdToRecord": "Запись при удержании",
    "stop": "Остановить запись",
    "recording": "Идёт запись",
    "transcribing": "Распознаю речь",
    "errorPermission": "Нет доступа к микрофону. Разрешите его в настройках браузера.",
    "errorMicUnavailable": "Микрофон недоступен.",
    "errorTooShort": "Слишком короткая запись.",
    "errorNoSpeech": "Не удалось разобрать речь — попробуйте ещё раз.",
    "errorUnsupported": "Неподдерживаемый формат записи.",
    "errorTooLarge": "Запись слишком длинная.",
    "errorInsufficientFunds": "Недостаточно средств для распознавания речи.",
    "errorCompanyArchived": "Компания в архиве — распознавание речи недоступно.",
    "errorUnavailable": "Распознавание речи сейчас недоступно.",
    "errorRateLimited": "Слишком много запросов на распознавание. Попробуйте позже.",
    "errorFailed": "Не удалось распознать речь."
  },
  "agreementPage": {
    "version": "Редакция {{version}}",
    "updated": "Обновлено {{date}}"
  },
  "generationBar": {
    "retry": "Повторить",
    "dismissError": "Скрыть ошибку",
    "parallelTitle": "Запустить ещё одну генерацию?",
    "parallelRunning_one": "Сейчас уже идёт {{count}} генерация этого вида. Новая пойдёт параллельно и станет отдельной версией.",
    "parallelRunning_few": "Сейчас уже идут {{count}} генерации этого вида. Новая пойдёт параллельно и станет отдельной версией.",
    "parallelRunning_many": "Сейчас уже идут {{count}} генераций этого вида. Новая пойдёт параллельно и станет отдельной версией.",
    "parallelRunning_other": "Сейчас уже идут {{count}} генерации этого вида. Новая пойдёт параллельно и станет отдельной версией.",
    "parallelCost": "Спишется ещё {{price}}.",
    "parallelNoCost": "Она спишется отдельно, как обычная генерация.",
    "parallelConfirm": "Запустить ещё одну",
    "runningCount_one": "{{count}} генерация",
    "runningCount_few": "{{count}} генерации",
    "runningCount_many": "{{count}} генераций",
    "runningCount_other": "{{count}} генерации",
    "runningCountHint_one": "Идёт {{count}} генерация этого вида — на полосе прогресс одной из них, остальные видны в версиях и задачах",
    "runningCountHint_few": "Идут {{count}} генерации этого вида — на полосе прогресс одной из них, остальные видны в версиях и задачах",
    "runningCountHint_many": "Идут {{count}} генераций этого вида — на полосе прогресс одной из них, остальные видны в версиях и задачах",
    "runningCountHint_other": "Идут {{count}} генерации этого вида — на полосе прогресс одной из них, остальные видны в версиях и задачах"
  }
}
